<div class="flex justify-content-center mt-4" [class.pointers]="allowPointerEvents">
  @for (input of configJson.inputs; track input.id ?? input.order ?? $index) {
    @for (option of input.options; track option.value ?? option.order ?? $index) {
      <div class="tall-square-button align-content-center" [class.button-selected]="selectedDecision === $index"
           tabindex="0" role="button"
           (click)="decisionButtonClick($index)"
           (keyup.enter)="decisionButtonClick($index)"
           (keyup.space)="decisionButtonClick($index)">
        <div class="flex justify-content-center">
          @if (isYesNo()) {
            <i [class]="option.value === 'yes' ? vm.yesIcon + ' yes-icon' : vm.noIcon + ' no-icon'"></i>
          }
        </div>
        <div class="flex justify-content-center pt-4 decision-container">
          @if (isYesNo()) {
            <p class="yes-no-label">{{ option.value === 'yes' ? vm.yesLabel : vm.noLabel }}</p>
          } @else {
            <div class="flex flex-column align-content-center">
              <h5>{{ option.label }}</h5>
              <p>{{ option.subLabel }}</p>
            </div>
          }
        </div>
      </div>
    }
  }
</div>
